import { createContext, useContext, useState } from 'react';

export type LayoutContextType = { showCart: boolean, toggleCart: () => void; hideCart: () => void; };

const LayoutContext = createContext<LayoutContextType>({
    showCart: false,
    toggleCart: () => {}, // default noop
    hideCart: () => {},
});

const useProviderLayout = () => {
    const [showCart, setShowCart] = useState<boolean>(false);

    const toggleCart = () => {
        setShowCart((prev) => !prev);
    };

    return {
        showCart,
        toggleCart,
        hideCart: () => setShowCart(false),
    };
};

export const LayoutProvider = ({ children }: { children: React.ReactNode }) => {
    const layout = useProviderLayout();

    return (
        <LayoutContext.Provider value={layout}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => {
    return useContext(LayoutContext);
};

export default LayoutContext;
